import axios from "axios"
import React, { useEffect, useState } from "react"
import { ImSpinner8 } from "react-icons/im"
import { formatSalesValue } from "../../utils/formatUtils"
import Navbar from "../Navbar"
import Footer from "../Footer"
import { toast } from "react-toastify"
import { MdAutorenew, MdError } from "react-icons/md"

const ItemSalesComparison = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL
    const today = new Date().toLocaleDateString('en-CA')

    const [startDate, setStartDate] = useState(today)
    const [endDate, setEndDate] = useState(today)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [data, setData] = useState(null)

    const token = localStorage.getItem("token")
    const userID = localStorage.getItem("userID")

    const fetchData = async () => {
        if (!token) return

        try {
            setLoading(true)

            const res = await axios.post(
                `${baseUrl}/salesitems-itemwise-alloutlets`,
                {
                    dateStart: startDate,
                    dateEnd: endDate,
                    token,
                    employee_id: Number(userID)
                },
            )

            setData(res.data)

        } catch (err) {
            toast.error(err.response?.data?.error ||
                err.response?.data?.message ||
                err.message ||
                "Failed to fetch item sales data.")
            setError(err.response?.data?.error ||
                err.response?.data?.message ||
                err.message ||
                "Failed to fetch item sales data.")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [token])

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />

            <div className="flex-grow px-3 pt-2 mb-3">
                <div className="px-3 py-2 bg-white rounded shadow-md max-w-4xl mx-auto">
                    <div className="flex flex-wrap items-center justify-between">
                        <label className="flex items-center gap-x-3 py-2 text-sm font-medium text-gray-700">
                            Start Date:
                            <input
                                type="date"
                                className="border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </label>

                        <button
                            onClick={fetchData}
                            className="flex items-center gap-1 px-3 py-1.5 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm"
                        >
                            {loading ?
                                <div className="flex justify-center items-center">
                                    <ImSpinner8 className="animate-spin text-purple-300" />
                                    <span className="ml-2">Loading...</span>
                                </div> : "View"}
                        </button>

                        <label className="flex items-center gap-x-3 py-2 text-sm font-medium text-gray-700">
                            End Date:
                            <input
                                type="date"
                                className="border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </label>
                    </div>
                </div>

                {/* Table */}
                {loading ? (
                    <div className="max-w-4xl mx-auto mt-4 rounded-md bg-blue-50 p-4">
                        <div className="flex gap-3 items-center justify-center">
                            <MdAutorenew className="h-5 w-5 text-blue-300 animate-spin" />
                            <div className="text-blue-700">
                                Fetching sales data...
                            </div>
                        </div>
                    </div>
                ) : error ? (
                    <div className="max-w-4xl mx-auto mt-4 rounded-md bg-red-50 p-4">
                        <div className="flex gap-3 justify-center items-stretch">
                            <MdError className="h-5 w-5 text-red-400" />
                            <div className="text-red-700">{error}</div>
                        </div>
                    </div>
                ) : (data &&
                    data.items &&
                    Object.keys(data.items).length > 0 ? (

                    // Object.entries(data.items).map(([categoryName, groups], catIdx) => {
                    //     return (
                    //         <div className="px-6">
                    //             <div key={catIdx} className="mt-8 border rounded-t-xl">

                    //                 {/* CATEGORY TITLE */}
                    //                 <div className="bg-slate-600 text-white px-4 py-2 font-semibold text-lg rounded-t-xl">
                    //                     {categoryName}
                    //                 </div>

                    //                 <table className="w-full text-sm text-center">

                    //                     {/* HEADER */}
                    //                     <thead className="bg-slate-100 sticky top-0 z-10 shadow-sm">
                    //                         <tr>
                    //                             <th className="px-3 py-2">Group</th>
                    //                             <th className="px-3 py-2">Item</th>
                    //                             <th className="px-3 py-2 border-gray-300 border-r">Rate</th>

                    //                             {data.outlets.map((outlet, idx) => (
                    //                                 <th key={idx} colSpan={2} className="px-3 py-2 border-gray-300 border-r border-b">
                    //                                     {outlet}
                    //                                 </th>
                    //                             ))}

                    //                             <th className="px-3 py-2">Item Total</th>
                    //                         </tr>

                    //                         <tr>
                    //                             <th></th>
                    //                             <th></th>
                    //                             <th className="border-gray-300 border-r"></th>

                    //                             {data.outlets.map((_, idx) => (
                    //                                 <React.Fragment key={idx}>
                    //                                     <th className="px-3 pb-2 border-gray-300 border-r">Qty</th>
                    //                                     <th className="px-3 pb-2 border-gray-300 border-r">Total</th>
                    //                                 </React.Fragment>
                    //                             ))}

                    //                             <th></th>
                    //                         </tr>
                    //                     </thead>

                    //                     <tbody>
                    //                         {Object.entries(groups).map(([groupName, items], gIdx) => {

                    //                             // GROUP TOTAL CALC
                    //                             const groupTotals = {};
                    //                             let groupGrandTotal = 0;

                    //                             data.outlets.forEach(outlet => {
                    //                                 groupTotals[outlet] = { qty: 0, total: 0 };
                    //                             });

                    //                             items.forEach(item => {
                    //                                 data.outlets.forEach(outlet => {
                    //                                     const outletData =
                    //                                         item.outlets[outlet] || { qty: 0, total: 0 };

                    //                                     groupTotals[outlet].qty += outletData.qty;
                    //                                     groupTotals[outlet].total += outletData.total;
                    //                                     groupGrandTotal += outletData.total;
                    //                                 });
                    //                             });

                    //                             return (
                    //                                 <React.Fragment key={gIdx}>

                    //                                     {/* GROUP HEADER */}
                    //                                     <tr className="bg-slate-200">
                    //                                         <td className="px-3 py-2 font-semibold text-slate-700">
                    //                                             {groupName}
                    //                                         </td>
                    //                                         <td colSpan={2 + data.outlets.length * 2} className="border-gray-300 border-r"></td>
                    //                                         <td></td>
                    //                                     </tr>

                    //                                     {/* ITEMS */}
                    //                                     {items.map((item, iIdx) => {

                    //                                         const rowTotal = data.outlets.reduce((sum, outlet) => {
                    //                                             const outletData =
                    //                                                 item.outlets[outlet] || { qty: 0, total: 0 };
                    //                                             return sum + outletData.total;
                    //                                         }, 0);

                    //                                         return (
                    //                                             <tr key={iIdx} className="px-3 py-2 border-t">
                    //                                                 <td></td>

                    //                                                 <td className="px-3 py-2 font-medium">
                    //                                                     {item.item_name}
                    //                                                 </td>

                    //                                                 <td className="px-3 py-2 border-gray-300 border-r">{formatSalesValue(item.rate)}</td>

                    //                                                 {data.outlets.map((outlet, oIdx) => {
                    //                                                     const outletData =
                    //                                                         item.outlets[outlet] || { qty: 0, total: 0 };

                    //                                                     return (
                    //                                                         <React.Fragment key={oIdx}>
                    //                                                             <td className="px-3 py-2 border-gray-300 border-r">{outletData.qty}</td>
                    //                                                             <td className="px-3 py-2 border-gray-300 border-r">{formatSalesValue(outletData.total)}</td>
                    //                                                         </React.Fragment>
                    //                                                     );
                    //                                                 })}

                    //                                                 <td className="font-semibold px-3 py-2">
                    //                                                     {formatSalesValue(rowTotal)}
                    //                                                 </td>
                    //                                             </tr>
                    //                                         );
                    //                                     })}

                    //                                     {/* GROUP TOTAL ROW */}
                    //                                     <tr className="bg-slate-100 font-semibold">
                    //                                         <td colSpan={3} className="border-gray-300 border-r"></td>

                    //                                         {data.outlets.map((outlet, idx) => (
                    //                                             <React.Fragment key={idx}>
                    //                                                 <td className="border-t-2 px-3 py-2 border-gray-300 border-r">
                    //                                                     {groupTotals[outlet].qty}
                    //                                                 </td>
                    //                                                 <td className="border-t-2 px-3 py-2 border-gray-300 border-r">
                    //                                                     {formatSalesValue(groupTotals[outlet].total)}
                    //                                                 </td>
                    //                                             </React.Fragment>
                    //                                         ))}

                    //                                         <td className="border-t-2 border-gray-300 px-3 py-2">
                    //                                             {formatSalesValue(groupGrandTotal)}
                    //                                         </td>
                    //                                     </tr>

                    //                                 </React.Fragment>
                    //                             );
                    //                         })}

                    //                         {/* CATEGORY GRAND TOTAL */}
                    //                         <tr className="bg-slate-300 font-semibold rounded-b-xl">
                    //                             <td colSpan={3} className="px-3 py-2 text-right">Grand Total</td>

                    //                             {data.outlets.map((outlet, idx) => {
                    //                                 let outletGrand = { qty: 0, total: 0 };

                    //                                 Object.values(groups).forEach(groupItems => {
                    //                                     groupItems.forEach(item => {
                    //                                         const outletData =
                    //                                             item.outlets[outlet] || { qty: 0, total: 0 };

                    //                                         outletGrand.qty += outletData.qty;
                    //                                         outletGrand.total += outletData.total;
                    //                                     });
                    //                                 });

                    //                                 return (
                    //                                     <React.Fragment key={idx}>
                    //                                         <td className="px-3 py-2">{outletGrand.qty}</td>
                    //                                         <td className="px-3 py-2">{formatSalesValue(outletGrand.total)}</td>
                    //                                     </React.Fragment>
                    //                                 );
                    //                             })}

                    //                             <td>
                    //                                 {formatSalesValue(
                    //                                     Object.values(groups).reduce((sum, groupItems) => {
                    //                                         return sum + groupItems.reduce((inner, item) => {
                    //                                             return inner + data.outlets.reduce((outletSum, outlet) => {
                    //                                                 const outletData =
                    //                                                     item.outlets[outlet] || { qty: 0, total: 0 };
                    //                                                 return outletSum + outletData.total;
                    //                                             }, 0);
                    //                                         }, 0);
                    //                                     }, 0)
                    //                                 )}
                    //                             </td>
                    //                         </tr>

                    //                     </tbody>
                    //                 </table>
                    //             </div>
                    //         </div>
                    //     );
                    // })

                    <div className="px-2 grid grid-cols-2 gap-6 mt-3">
                        {Object.entries(data.items)
                            .sort(([a], [b]) => {
                                const order = ["food", "beverage"];

                                const aIndex = order.indexOf(a.toLowerCase());
                                const bIndex = order.indexOf(b.toLowerCase());

                                if (aIndex !== -1 && bIndex !== -1) {
                                    return aIndex - bIndex;
                                }

                                if (aIndex !== -1) return -1;

                                if (bIndex !== -1) return 1;

                                return 0;
                            })
                            .map(([categoryName, groups], catIdx) => {
                                return (
                                    <div>
                                        <div key={catIdx} className="border">

                                            {/* CATEGORY TITLE */}
                                            <div className="bg-slate-500 text-white px-4 py-2 font-semibold text-base">
                                                {categoryName}
                                            </div>

                                            {/* TABLE HERE */}
                                            <div className="max-h-[650px] overflow-y-auto tiny-scrollbar">
                                                <table className="w-full text-sm text-center">

                                                    {/* HEADER */}
                                                    <thead className="bg-slate-100 sticky top-0 z-10 shadow-sm text-sm">
                                                        <tr>
                                                            <th className="p-2 border-gray-300 border-r font-semibold">Item</th>
                                                            <th className="p-2 border-gray-300 border-r font-semibold">Rate</th>

                                                            {data.outlets.map((outlet, idx) => (
                                                                <th key={idx} colSpan={2} className="p-2 border-gray-300 border-r border-b font-semibold">
                                                                    {outlet}
                                                                </th>
                                                            ))}

                                                            <th className="p-2 font-semibold">Item Total</th>
                                                        </tr>

                                                        <tr>
                                                            <th className="border-gray-300 border-r"></th>
                                                            <th className="border-gray-300 border-r"></th>

                                                            {data.outlets.map((_, idx) => (
                                                                <React.Fragment key={idx}>
                                                                    <th className="px-2 pt-1 pb-2 border-gray-300 border-r font-semibold">Qty</th>
                                                                    <th className="px-2 pt-1 pb-2 border-gray-300 border-r font-semibold">Total</th>
                                                                </React.Fragment>
                                                            ))}

                                                            <th></th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {Object.entries(groups).map(([groupName, items], gIdx) => {

                                                            // GROUP TOTAL CALC
                                                            const groupTotals = {};
                                                            let groupGrandTotal = 0;

                                                            data.outlets.forEach(outlet => {
                                                                groupTotals[outlet] = { qty: 0, total: 0 };
                                                            });

                                                            items.forEach(item => {
                                                                data.outlets.forEach(outlet => {
                                                                    const outletData =
                                                                        item.outlets[outlet] || { qty: 0, total: 0 };

                                                                    groupTotals[outlet].qty += outletData.qty;
                                                                    groupTotals[outlet].total += outletData.total;
                                                                    groupGrandTotal += outletData.total;
                                                                });
                                                            });

                                                            return (
                                                                <React.Fragment key={gIdx}>

                                                                    {/* GROUP HEADER */}
                                                                    <tr className="bg-slate-200">
                                                                        <td colSpan={3} className="text-center p-2 font-semibold text-slate-700 text-sm">
                                                                            {groupName}
                                                                        </td>
                                                                        <td colSpan={data.outlets.length * 2} className="p-2 font-semibold text-slate-700">
                                                                        </td>
                                                                    </tr>

                                                                    {/* ITEMS */}
                                                                    {items.map((item, iIdx) => {

                                                                        const rowTotal = data.outlets.reduce((sum, outlet) => {
                                                                            const outletData =
                                                                                item.outlets[outlet] || { qty: 0, total: 0 };
                                                                            return sum + outletData.total;
                                                                        }, 0);

                                                                        return (
                                                                            <tr key={iIdx} className="p-2 border-t">
                                                                                <td className="p-2 font-medium border-r">
                                                                                    {item.item_name}
                                                                                </td>

                                                                                <td className="p-2 border-gray-300 border-r">{formatSalesValue(item.rate)}</td>

                                                                                {data.outlets.map((outlet, oIdx) => {
                                                                                    const outletData =
                                                                                        item.outlets[outlet] || { qty: 0, total: 0 };

                                                                                    return (
                                                                                        <React.Fragment key={oIdx}>
                                                                                            <td className="p-2 border-gray-300 border-r">{outletData.qty}</td>
                                                                                            <td className="p-2 border-gray-300 border-r">{formatSalesValue(outletData.total)}</td>
                                                                                        </React.Fragment>
                                                                                    );
                                                                                })}

                                                                                <td className="font-semibold p-2">
                                                                                    {formatSalesValue(rowTotal)}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}

                                                                    {/* GROUP TOTAL ROW */}
                                                                    <tr className="bg-slate-100 font-semibold">
                                                                        <td colSpan={2} className="border-gray-300 border-r"></td>

                                                                        {data.outlets.map((outlet, idx) => (
                                                                            <React.Fragment key={idx}>
                                                                                <td className="border-t-2 p-2 border-gray-300 border-r">
                                                                                    {groupTotals[outlet].qty}
                                                                                </td>
                                                                                <td className="border-t-2 p-2 border-gray-300 border-r">
                                                                                    {formatSalesValue(groupTotals[outlet].total)}
                                                                                </td>
                                                                            </React.Fragment>
                                                                        ))}

                                                                        <td className="border-t-2 border-gray-300 p-2">
                                                                            {formatSalesValue(groupGrandTotal)}
                                                                        </td>
                                                                    </tr>

                                                                </React.Fragment>
                                                            );
                                                        })}

                                                        {/* CATEGORY GRAND TOTAL */}
                                                        <tr className="bg-slate-300 font-semibold sticky bottom-0 z-10">
                                                            <td colSpan={2} className="p-2 text-right">Grand Total</td>

                                                            {data.outlets.map((outlet, idx) => {
                                                                let outletGrand = { qty: 0, total: 0 };

                                                                Object.values(groups).forEach(groupItems => {
                                                                    groupItems.forEach(item => {
                                                                        const outletData =
                                                                            item.outlets[outlet] || { qty: 0, total: 0 };

                                                                        outletGrand.qty += outletData.qty;
                                                                        outletGrand.total += outletData.total;
                                                                    });
                                                                });

                                                                return (
                                                                    <React.Fragment key={idx}>
                                                                        <td className="p-2">{outletGrand.qty}</td>
                                                                        <td className="p-2">{formatSalesValue(outletGrand.total)}</td>
                                                                    </React.Fragment>
                                                                );
                                                            })}

                                                            <td>
                                                                {formatSalesValue(
                                                                    Object.values(groups).reduce((sum, groupItems) => {
                                                                        return sum + groupItems.reduce((inner, item) => {
                                                                            return inner + data.outlets.reduce((outletSum, outlet) => {
                                                                                const outletData =
                                                                                    item.outlets[outlet] || { qty: 0, total: 0 };
                                                                                return outletSum + outletData.total;
                                                                            }, 0);
                                                                        }, 0);
                                                                    }, 0)
                                                                )}
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>

                ) : (
                    <div className="max-w-4xl mx-auto mt-4 text-sm italic font-semibold text-center rounded-md bg-gray-50 p-4">
                        No sales data available
                    </div>
                ))}
            </div>

            <Footer />
        </div >
    )
}

export default ItemSalesComparison